import React from 'react';
import FourByFour from '../../../../../../Assets/images/SudokuOriginsImages/4by4.png';
import SixBySix from '../../../../../../Assets/images/SudokuOriginsImages/6by6.png';
import NineByNine from '../../../../../../Assets/images/SudokuOriginsImages/9by9.png';
import '../../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/SudokuOriginsStyles/SudokuOrigins.css';

export const SudokuOrigins = () => (
    <div className="origins-content">
        <div className="grid-container">
            <ul className="grid-list">
                <li className="grid-item">
                    <img
                        src={FourByFour}
                        alt="4X4 Sudoku example"
                        className="grid-image"
                        style={{ width: '100px' }}
                    />
                    <span className="size-label">4 X 4</span>
                </li>
                <li className="grid-item">
                    <img
                        src={SixBySix}
                        alt="6X6 Sudoku example"
                        className="grid-image"
                        style={{ width: '135px' }}
                    />
                    <span className="size-label">6 X 6</span>
                </li>
                <li className="grid-item">
                    <img
                        src={NineByNine}
                        alt="9X9 Sudoku example"
                        className="grid-image"
                        style={{ width: '180px' }}
                    />
                    <span className="size-label">9 X 9</span>
                </li>
            </ul>
        </div>

        <ul className="bullet-list">
            <li>Inspired by Latin squares; first published in 1979 by Howard Garns.</li>
            <li>Became popular in Japan in the 1980s, renamed &ldquo;Sudoku.&rdquo; Gained global fame in the 2000s.</li>
            <li>9x9 grid with nine 3x3 subgrids; fill with 1 to 9 without repeats in rows, columns, or subgrids.</li>
            <li>Loved by millions, with many variations and new challenges.</li>
        </ul>
    </div>
);